module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#arrow",
      toString: function () {
        return this.url;
      }
    }